'use client';

import { Card } from '@entities/card';
import { useNotesListQuery } from '@shared/api';
import type { Locale } from '@shared/libs';
import { listStyle } from '@shared/ui';

type TProps = {
  locale: Locale;
};

export const Data = ({ locale }: TProps) => {
  const { data: favorites } = useNotesListQuery({
    favorites_only: 'y',
    pagelen: 100,
  });

  if (favorites && favorites.data.length === 0) {
    return <p>{locale.PAGE_FAVORITES_EMPTY}</p>;
  }

  return (
    <div className={listStyle.list}>
      {favorites?.data.map((item) => <Card.GridNote key={item.id} {...item} />)}
    </div>
  );
};
